import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import AtomButton from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import MoleculeBadgeCounter from '@s-ui/react-molecule-badge-counter'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import {useSearchTags} from '@adv-mt/mt-search-tags'
import IconFilter from '@adv-mt/mt-svg-icons/lib/Filter'

import {BUTTON_PROPS as searchFiltersButtonProps, DESIGNS as searchFiltersButtonDesigns} from './config.js'

const DEFAULT_EMPTY_LITERAL = ''

const FilterButton = ({customButtonText = DEFAULT_EMPTY_LITERAL, onClick = () => {}, design, pageName, search}) => {
  const [isMounted, setIsMounted] = useState(false)

  const {i18n} = useContext(Context)

  const isMobileOrWider = useMediaQuery(useMediaQueryBreakpoints.xs)

  const searchTags = useSearchTags({pageName, search})

  useMount(() => {
    setIsMounted(true)
  })

  const designButtonProps = searchFiltersButtonProps[design]

  const isHighlightedDesign = design === searchFiltersButtonDesigns.HIGHLIGHTED
  const isPrimaryDesign = design === searchFiltersButtonDesigns.PRIMARY
  const isCompressedDesign = design === searchFiltersButtonDesigns.COMPRESSED

  const CompressedDesignLeftIcon = searchTags.length ? (
    <MoleculeBadgeCounter label={searchTags.length}>
      <IconFilter aria-hidden role="presentation" size={designButtonProps.iconSize} />
    </MoleculeBadgeCounter>
  ) : (
    <IconFilter aria-hidden role="presentation" size={designButtonProps.iconSize} />
  )

  const DefaultLeftIcon =
    isMobileOrWider || isHighlightedDesign || isPrimaryDesign ? (
      <IconFilter aria-hidden role="presentation" size={designButtonProps.iconSize} />
    ) : null

  const LeftIcon = isCompressedDesign ? CompressedDesignLeftIcon : DefaultLeftIcon

  const RightIcon =
    (isHighlightedDesign || isPrimaryDesign) && Boolean(searchTags.length) ? (
      <MoleculeBadgeCounter label={searchTags.length} />
    ) : null

  const hasCustomButtonText = Boolean(customButtonText)

  const filterButtonText = hasCustomButtonText ? i18n.t(customButtonText) : i18n.t('COMMON_FILTER')

  return (
    <AtomButton
      {...designButtonProps}
      aria-haspopup="dialog"
      disabled={!isMounted}
      leftIcon={LeftIcon}
      onClick={onClick}
      rightIcon={RightIcon}
      title={i18n.t('COMMON_FILTER')}
    >
      {!isCompressedDesign && filterButtonText}
    </AtomButton>
  )
}

FilterButton.propTypes = {
  customButtonText: PropTypes.string,
  onClick: PropTypes.func,
  design: PropTypes.oneOf(Object.keys(searchFiltersButtonDesigns)),
  pageName: PropTypes.string,
  search: PropTypes.object.isRequired
}
export default FilterButton
